.text {
  font: var(--font-body-2);
  color: var(--color-text-secondary);
}
